.order-number-column {
  width: 50px;
}
